var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('MapArea',{attrs:{"context":_vm.context,"can-draw":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }